import React, {memo} from 'react'
import styled from '@emotion/styled'

import {cssTheme} from '@vio/atlas/themes'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

export const HighlightedTitleAccent = styled.span`
  color: ${cssTheme.colors.homepage.highlightedTitle.content};
`

const TextSecondaryColor = styled.span`
  color: ${cssTheme.colors.content.neutral.inverse};
`

interface TextProps {
  children: React.ReactNode
  secondary?: boolean
}

const Text: React.FC<TextProps> = ({children, secondary}) => {
  if (secondary) return <TextSecondaryColor>{children}</TextSecondaryColor>

  return <HighlightedTitleAccent>{children}</HighlightedTitleAccent>
}

interface Props {
  source:
    | 'ExtendYourStay'
    | 'HeroSection'
    | 'RecentSearchHistory'
    | 'SuggestedHotels'
    | 'TopDealsForTonight'
    | 'YourStays'
    | 'MonthlyTravelSavings'
    | 'SocialProofSection'
    | 'UnlockExclusiveSavings'
    | 'UnlockExclusiveSavingsApp'
    | 'HopperAds'
}
const TitleComponent: React.FC<Props> = ({source}) => {
  switch (source) {
    case 'ExtendYourStay':
      return (
        <FormattedMessageWrapper
          id="homePage.wantToStayLongerGR"
          defaultMessage="Want to <span>stay longer?</span>"
          values={{
            span: chunks => <Text>{chunks}</Text>
          }}
        />
      )
    case 'HeroSection':
      return (
        <FormattedMessageWrapper
          id="homePage.heroTitle"
          defaultMessage="<span>Better value,</span> every stay"
          values={{
            span: chunks => <Text>{chunks}</Text>
          }}
        />
      )
    case 'RecentSearchHistory':
      return (
        <FormattedMessageWrapper
          id="homePage.yourRecentSearchesGR"
          defaultMessage="Your <span>recent</span> searches"
          values={{
            span: chunks => <Text>{chunks}</Text>
          }}
        />
      )
    case 'SuggestedHotels':
      return (
        <FormattedMessageWrapper
          id="homePage.continueYourSearchGR"
          defaultMessage="<span>Continue</span> your search"
          values={{
            span: chunks => <Text>{chunks}</Text>
          }}
        />
      )
    case 'TopDealsForTonight':
      return (
        <FormattedMessageWrapper
          id="homePage.ourTopDealsForTonightGR"
          defaultMessage="<span>Our top deals</span> for tonight"
          values={{
            span: chunks => <Text>{chunks}</Text>
          }}
        />
      )
    case 'YourStays':
      return (
        <FormattedMessageWrapper
          id="homePage.yourUpcomingStaysGR"
          defaultMessage="Your <span>upcoming</span> stays"
          values={{
            span: chunks => <Text>{chunks}</Text>
          }}
        />
      )
    case 'MonthlyTravelSavings':
      return (
        <FormattedMessageWrapper
          id="homePage.savingTitle"
          defaultMessage="We helped our travelers <br></br><span>save {price}</span> last month"
          values={{
            span: chunks => <Text>{chunks}</Text>,
            br: () => <br />,
            price: '$6,327,450'
          }}
        />
      )
    case 'SocialProofSection':
      return (
        <FormattedMessageWrapper
          id="homePage.socialProofTitle"
          defaultMessage="And they <span>love talking</span> about us"
          values={{
            span: chunks => <Text>{chunks}</Text>
          }}
        />
      )
    case 'UnlockExclusiveSavings':
      return (
        <FormattedMessageWrapper
          id="homePage.appAdvantagesTitle"
          defaultMessage="Unlock <span>exclusive<br></br>savings</span> on our app"
          values={{
            span: chunks => <Text secondary>{chunks}</Text>,
            br: () => <br />
          }}
        />
      )
    case 'UnlockExclusiveSavingsApp':
      return (
        <FormattedMessageWrapper
          id="homePage.appAdvantagesTitle"
          defaultMessage="Unlock <span>exclusive<br></br>savings</span> on our app"
          values={{
            span: chunks => <Text>{chunks}</Text>,
            br: () => <br />
          }}
        />
      )
    case 'HopperAds':
      return (
        <FormattedMessageWrapper
          id="homePage.hopperAdsTitle"
          defaultMessage="<span>Save more</span> when you sign in"
          values={{
            span: chunks => <Text>{chunks}</Text>
          }}
        />
      )
    default:
      return null
  }
}

export const HighlightedTitle = memo(TitleComponent)
